/* ==========================================================================
   PRODUCT PAGE

   Two small behaviours: the review score jumps to the review widget, and the
   image gallery's arrows wrap around instead of dead-ending.
   ========================================================================== */

/* ---- review score jump ---------------------------------------------------
   The score on the price row is a button, not a link, because the widget it
   points at is an app block whose id is generated per install. Rather than
   hard-code an id that changes the next time the app is reinstalled, this finds
   the widget by class at click time. If it is not on the page - block removed,
   app uninstalled - nothing happens and nothing throws.
   -------------------------------------------------------------------------- */

(function () {
  var WIDGET =
    '.jdgm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews, [id*="judge_me_reviews_review_widget"]';

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-stk-reviews]');
    if (!trigger) return;

    var widget = document.querySelector(WIDGET);
    if (!widget) return;

    event.preventDefault();

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    widget.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
})();

/* ---- the gallery arrows wrap around --------------------------------------
   Dawn's slider-component disables prev on the first slide and next on the
   last, so the gallery is a dead end at both ends. Thomas: "the image slider
   carousel SHOULD go both ways even if you're at image one. it should go back
   to the last image from one."

   Two halves. Dawn keeps setting `disabled` on every update, so an observer
   takes it straight back off - a disabled button fires no click at all, so
   without that there is nothing to intercept. Then a capture-phase listener
   sees the click before Dawn's own handler: at an end it jumps to the other
   end and stops the event; anywhere else it does nothing and Dawn advances one
   slide as usual.

   The ends are found by WHICH SLIDE IS CENTRED, not by comparing scrollLeft
   against scrollWidth. With centre snapping and a padded scrollport the last
   snap point sits short of the maximum scroll, and an intermediate snap can
   land a long way from it, so a tolerance on scrollLeft never recognised the
   ends reliably. Nearest-slide-to-centre has no such edge cases.

   The jump is instant, not smooth: sixteen images is about 5,000px of travel,
   which animated reads as a rewind and takes seconds.

   Scoped to the slider holding .product__media-list, so the thumbnail strip -
   which has its own prev/next with the same class names - is untouched.
   -------------------------------------------------------------------------- */

(function () {
  function mediaSlider(el) {
    var comp = el.closest('slider-component');
    if (!comp) return null;
    var list = comp.querySelector('.product__media-list');
    return list ? { comp: comp, list: list } : null;
  }

  function activeIndex(list) {
    var centre = list.scrollLeft + list.clientWidth / 2;
    var best = Infinity;
    var idx = 0;
    for (var i = 0; i < list.children.length; i++) {
      var el = list.children[i];
      var d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - centre);
      if (d < best) {
        best = d;
        idx = i;
      }
    }
    return idx;
  }

  /* scrollIntoView, not an arithmetic scrollTo. Computing the target from
     offsetLeft looked right - and landed one slide short every time, because
     scroll-snap-type: mandatory re-snaps after a programmatic scroll and the
     computed position sat a rounding away from the snap point it was aiming at.
     The browser's own inline centring already knows where the snap points are
     and respects scroll-padding. block:'nearest' keeps the page from scrolling
     vertically to reach it. */
  /* 'instant', not 'auto'. 'auto' means "use the CSS scroll-behavior", and the
     theme sets scroll-behavior: smooth, so the wrap animated across all sixteen
     images - about five seconds of travel, and it read as a rewind rather than a
     loop. It also made the jump look like it was landing one slide short,
     because it was still moving when measured. */
  function centreOn(list, el) {
    el.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
  }

  /* Dawn re-disables on every scroll and every variant change; take it off
     again each time. Removing the attribute fires the observer once more, but
     then there is nothing left to remove, so it settles rather than looping. */
  function enable(root) {
    var buttons = root.querySelectorAll('.slider-button[disabled]');
    for (var i = 0; i < buttons.length; i++) {
      if (mediaSlider(buttons[i])) buttons[i].removeAttribute('disabled');
    }
  }

  function watch() {
    var comps = document.querySelectorAll('.product__media-wrapper slider-component');
    for (var i = 0; i < comps.length; i++) {
      (function (comp) {
        if (!comp.querySelector('.product__media-list')) return;
        if (comp.dataset.stkWrap === '1') return;
        comp.dataset.stkWrap = '1';
        enable(comp);
        new MutationObserver(function () {
          enable(comp);
        }).observe(comp, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
      })(comps[i]);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.slider-button');
      if (!btn) return;

      var found = mediaSlider(btn);
      if (!found) return;

      var list = found.list;
      var last = list.children.length - 1;
      if (last < 1) return;

      var idx = activeIndex(list);
      var isPrev = btn.classList.contains('slider-button--prev');

      if (isPrev && idx === 0) {
        event.preventDefault();
        event.stopPropagation();
        centreOn(list, list.children[last]);
      } else if (!isPrev && idx === last) {
        event.preventDefault();
        event.stopPropagation();
        centreOn(list, list.children[0]);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  /* The theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', watch);
})();


/* ==========================================================================
   INSTALMENT LINE - put it where the setting says

   Thomas asked for the "Pay in 3 interest-free instalments" line either between
   the Buy with Shop button and More payment options, or under the price.
   Neither is somewhere a theme block can be dragged: the price is another
   block's territory, and the wallet button and the More payment options link
   are BOTH emitted by the single {{ form | payment_button }} filter, as two
   children of Shopify's <shopify-accelerated-checkout> element.

   THE FIRST ATTEMPT INSERTED THE NODE INTO THAT ELEMENT AND IT VANISHED.
   shopify-accelerated-checkout hydrates after load and rewrites its own
   children, taking our node with it - which is why the block appeared to not
   render at all. Confirmed by marker: the Liquid arm ran and emitted the div,
   and the div was gone from the DOM by the time anything measured it.

   So nothing is ever inserted into a vendor element now. "price" moves the node
   next to our own price row. "wallet" moves it into .product-form__buttons -
   Dawn's container, which nobody else rewrites - and flattens the vendor
   wrappers with display:contents so CSS `order` can put the line between the
   two buttons without touching their DOM at all.
   ========================================================================== */

(function () {
  var HOST = 'stkt-host';

  function place() {
    var node = document.querySelector('[data-stk-terms]');
    if (!node) return true;

    var where = node.getAttribute('data-stk-terms');
    if (where === 'block') return true;

    if (where === 'price') {
      var row = document.querySelector('.stkp');
      if (!row) return false;
      if (row.nextElementSibling !== node) {
        row.parentNode.insertBefore(node, row.nextSibling);
      }
      return true;
    }

    /* 'wallet' is withdrawn - see the note in stk-pdp.css. It reordered the
       buttons and put More payment options above Add to cart. Anything still
       set to it falls back to under the price rather than doing nothing. */
    var row = document.querySelector('.stkp');
    if (!row) return false;
    if (row.nextElementSibling !== node) {
      row.parentNode.insertBefore(node, row.nextSibling);
    }
    return true;
  }

  function run() {
    if (place()) return;
    /* The wallet button is injected by Shopify well after load, so retry until
       it exists, then stop. Ten seconds, then give up quietly. */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (place() || tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();


/* ==========================================================================
   ARTWORK PATHS v2 - fold the upload fields into the card

   The artwork_paths block renders the card; the Stickiply Uploads app block
   renders the fields as the NEXT block in the template. This joins them:
   the app block's wrapper is tagged .stka2-fields, closed by default, and
   the card's Upload artwork row toggles it. Everything inside the wrapper
   belongs to the app - fields, count rules, validation - and is not
   touched, moved or re-rendered.

   Two guards. Without JS nothing is tagged, so the fields simply stay
   visible below the card - the fold can never lock anyone out. And if the
   app raises an error while the fields are closed (Add to cart with a
   required file missing), the observer opens them so the message is seen.
   ========================================================================== */

(function () {
  function isFileDrag(e) {
    var t = e.dataTransfer && e.dataTransfer.types;
    return !!t && Array.prototype.indexOf.call(t, 'Files') !== -1;
  }

  /* 24 Sep 2026 review: on any page with the upload widget, a file dropped
     outside a drop box must not make the browser open it and leave the page
     (uploads and choices lost). Drop targets that take the file (the app's
     box, the upload tile) cancel the event themselves first; anywhere else
     the drop is refused with a "no" cursor rather than silently eaten. */
  var guarded = false;
  function guardDrops() {
    if (guarded || !document.querySelector('[data-stickiply-artwork-upload]')) return;
    guarded = true;
    document.addEventListener('dragover', function (e) {
      if (!isFileDrag(e) || e.defaultPrevented) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'none';
    });
    document.addEventListener('drop', function (e) {
      if (isFileDrag(e) && !e.defaultPrevented) e.preventDefault();
    });
  }

  function setup() {
    guardDrops();
    var card = document.querySelector('[data-stka2]');
    /* A product with fields but no creator link (custom-backing-cards) has no
       card to join: the widget draws its own card instead (.sau-solo), with
       the caption the artwork_paths block rendered for it (translatable). */
    if (!card) {
      var solo = document.querySelector('[data-stickiply-artwork-upload]');
      var cap = document.querySelector('[data-stka2-solo-cap]');
      if (solo) {
        solo.classList.add('sau-solo');
        if (cap && !solo.querySelector('.stka2__cap')) {
          cap.hidden = false;
          solo.insertBefore(cap, solo.firstChild);
        }
      }
      return;
    }
    if (card.dataset.stka2Wired === '1') return;
    var toggle = card.querySelector('[data-stka2-toggle]');
    if (!toggle) return;

    var widget = document.querySelector('[data-stickiply-artwork-upload]');
    if (!widget) return;

    /* The widget sits inside an app-block wrapper; walk up to the element
       that is the card's sibling so the whole block is folded, not just the
       widget's inner div. */
    var fields = widget;
    while (fields.parentElement && fields.parentElement !== card.parentElement) {
      fields = fields.parentElement;
    }
    if (fields === card || fields.parentElement !== card.parentElement) return;

    card.dataset.stka2Wired = '1';
    fields.classList.add('stka2-fields');
    card.classList.add('stka2--joined');

    /* The bookmark zip note sits under the upload box, where the file goes
       (Thomas, 24 Sep: "move the zip hint to below the upload field"). The
       app builds its box after fetching its config, so this waits for it. */
    var note = card.querySelector('.stka2__note');
    function placeNote() {
      if (!note || note.dataset.placed === '1') return;
      var dz = fields.querySelector('.sau-dropzone');
      if (!dz) return;
      dz.insertAdjacentElement('afterend', note);
      note.dataset.placed = '1';
    }
    /* Products with NAMED slots (bookmark + backing card, sticker sheet +
       background) keep both slots in view: the panel opens by itself once the
       app has drawn them, without opening the file browser (Thomas, 24 Sep:
       "for sticker sheet and magnetic bookmark should always be visable. the
       2 fields"). Interchangeable lists (vinyl, magnets) keep the tile. */
    var namedOpened = false;
    function openNamed() {
      if (namedOpened || !widget.querySelector('.sau-row-empty')) return;
      namedOpened = true;
      widget.classList.add('sau-named');
      setOpen(true);
    }
    function onWidget() { placeNote(); openNamed(); }
    onWidget();
    new MutationObserver(onWidget).observe(widget, { subtree: true, childList: true });

    function setOpen(open) {
      card.classList.toggle('stka2--open', open);
      fields.classList.toggle('stka2-fields--closed', !open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* The app hides its root, or its field wraps, when the selected variant
       collects no artwork (READY TO GO designs) and shows them again on a DIY
       variant - its count rules, not ours. The upload tile follows the app:
       no fields, no tile. Before the app has rendered (the root starts
       hidden while it fetches its config) the tile stays, so the card does
       not jump when the fields arrive. */
    function syncUpload() {
      var rendered = !!widget.querySelector('.sau-field');
      var off = rendered && (widget.hidden || !widget.querySelector('.sau-field:not([hidden])'));
      card.classList.toggle('stka2--noupload', off);
      if (off) setOpen(false);
    }

    setOpen(false);
    syncUpload();

    /* 24 Sep 2026: the upload tile is a drop area (U2), so a tap does what a
       tap on a drop area does: the app's own box takes its place (the tile
       hides while open, CSS) and its file browser opens in the same gesture.
       The box's click handler is the app's; it ignores the tap when full. */
    toggle.addEventListener('click', function () {
      setOpen(true);
      var dz = fields.querySelector('.sau-dropzone');
      if (dz) dz.click();
    });

    /* 24 Sep 2026: the upload row is drawn as a drop target (dashed), so it
       behaves as one. A file dragged onto it opens the fields and turns it
       green; a file dropped on it is handed to the app's own drop box, which
       does all the checking. If a browser will not let the drop be handed
       on, the box is open underneath and takes it on the next try. A drop
       anywhere else is refused by guardDrops(). */
    var dragDepth = 0;
    toggle.addEventListener('dragover', function (e) {
      if (isFileDrag(e) && !card.classList.contains('stka2--noupload')) e.preventDefault();
    });
    toggle.addEventListener('dragenter', function (e) {
      if (!isFileDrag(e) || card.classList.contains('stka2--noupload')) return;
      e.preventDefault();
      dragDepth++;
      toggle.classList.add('stka2__tile--drag');
      setOpen(true);
    });
    toggle.addEventListener('dragleave', function () {
      dragDepth = Math.max(0, dragDepth - 1);
      if (!dragDepth) toggle.classList.remove('stka2__tile--drag');
    });
    toggle.addEventListener('drop', function (e) {
      dragDepth = 0;
      toggle.classList.remove('stka2__tile--drag');
      if (!isFileDrag(e) || card.classList.contains('stka2--noupload')) return;
      e.preventDefault();
      var dz = fields.querySelector('.sau-dropzone');
      if (!dz || !e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
      try {
        dz.dispatchEvent(new DragEvent('drop', { bubbles: true, cancelable: true, dataTransfer: e.dataTransfer }));
      } catch (err) { /* box is open; the next drop lands in it */ }
    });
    new MutationObserver(syncUpload).observe(widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden'],
    });

    new MutationObserver(function () {
      if (card.classList.contains('stka2--open')) return;
      var err = fields.querySelector('.sau-error:not([hidden])');
      if (err && err.textContent.trim()) setOpen(true);
    }).observe(fields, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();


/* ==========================================================================
   OPTIONS FOLD TO A SUMMARY ONCE ARTWORK IS IN

   Thomas, 24 Sep 2026: uploading two or more files pushed Add to cart below
   the fold. He picked B of stickiply-uploads/spec/options-collapse-2026-09-24
   ("i love B"): when a file is uploaded, the options card (646px on custom
   vinyl, measured) folds to a 2x2 of black boxes, each option and its
   choice, plus Designs. Quantity shows no price.

   After trying it he changed three things, all here:
   - The boxes are black like a chosen option.
   - Tapping an option box opens the FULL card and it stays open, so several
     options can be changed in one go; a Done button at the foot of the card
     folds it, and so does the next upload. (It used to fold after every
     pick, which meant opening it again for each option.)
   - Designs is another upload (opens the file browser); when every slot is
     full it scrolls to the uploaded list instead.
   The fold animates its height over 250ms and holds the artwork card still
   on screen, instead of swapping in one frame and jumping the page.

   Dawn replaces <variant-selects> on every pick, so the summary is its
   sibling and the fold is a class on the column that holds both; the new
   element inherits it, and the Done button is put back into each new one.
   variant-chips.js measures the chosen chip to place its black highlight;
   measured while the card is hidden it gets 0 and hides the highlight, which
   left the chosen option white on white (Thomas's "blank options"). A resize
   event after every reveal makes it measure again.
   ========================================================================== */

(function () {
  var SVG = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  };
  var ICON = {
    size: SVG('<path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/>'),
    finish: SVG('<path d="M12 3l8 9-8 9-8-9z"/>'),
    qty: SVG('<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>'),
    style: SVG('<path d="m12 3 9 5-9 5-9-5z"/><path d="m3 13 9 5 9-5"/>'),
    other: SVG('<circle cx="12" cy="12" r="4"/>'),
    designs: SVG('<rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/>'),
    edit: SVG('<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>'),
    plus: SVG('<path d="M12 5v14"/><path d="M5 12h14"/>'),
    check: SVG('<path d="m5 12 5 5 9-10"/>'),
  };
  function iconFor(name) {
    var n = name.toLowerCase();
    if (/size/.test(n)) return ICON.size;
    if (/finish|material|base|laminate/.test(n)) return ICON.finish;
    if (/quantity|qty|pack/.test(n)) return ICON.qty;
    if (/style|kit|type/.test(n)) return ICON.style;
    return ICON.other;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  /* P172 (2 Oct 2026): the summary's words in the page language, read from the stk-i18n-stk-pdp island
     that sections/main-product.liquid renders; English is the fallback. fill() puts values into the
     [name]-style placeholders in one pass. */
  var stkT = window.stkT || function (k, f) { return f; };
  function fill(s, o) {
    return String(s).replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(o, k) ? String(o[k]) : m; });
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 250;

  function init() {
    var vs = document.querySelector('variant-selects');
    var widget = document.querySelector('[data-stickiply-artwork-upload]');
    if (!vs || !widget || !vs.querySelector('fieldset')) return;
    var host = vs.parentElement;
    if (!host || host.dataset.stkOptsum === '1') return;
    host.dataset.stkOptsum = '1';

    var sum = document.createElement('div');
    sum.className = 'stk-optsum';
    sum.hidden = true;
    host.insertBefore(sum, vs);
    var folded = false;
    var lastCount = 0;

    function current() { return host.querySelector('variant-selects'); }
    function designs() { return widget.querySelectorAll('.sau-row:not(.sau-row-empty)').length; }
    function anchor() { return document.querySelector('[data-stka2]') || widget; }
    function dropzone() { return widget.querySelector('.sau-dropzone'); }
    function full() { var dz = dropzone(); return !dz || dz.getAttribute('aria-disabled') === 'true'; }
    function replaceChips() { window.dispatchEvent(new Event('resize')); }

    function render() {
      var v = current();
      if (!v) return;
      var cells = Array.prototype.map.call(v.querySelectorAll('fieldset'), function (f, i) {
        var lg = f.querySelector('legend');
        var name = lg ? lg.textContent.trim().replace(/\s+/g, ' ') : fill(stkT('stk.main_product.optsum_option', 'Option [n]'), { n: i + 1 });  /* P172 */
        var c = f.querySelector('input:checked');
        var val = c ? c.value : '';
        /* the chosen row's SAVE % tag comes along (Thomas, 24 Sep); its price does not */
        var lab = c && f.querySelector('label[for="' + c.id + '"]');
        var badge = lab && lab.querySelector('.vrow__badge');
        var tag = badge && badge.textContent.trim() ? ' <span class="stk-optsum__tag">' + esc(badge.textContent.trim()) + '</span>' : '';
        return '<button type="button" class="stk-optsum__cell" data-opt="' + i + '" aria-label="' + esc(fill(stkT('stk.main_product.optsum_change_aria', 'Change [name], now [value]'), { name: name, value: val })) + '">' +  /* P172 */
          '<span class="stk-optsum__ic">' + iconFor(name) + '</span>' +
          '<span class="stk-optsum__tx"><span class="stk-optsum__k">' + esc(name) + '</span><span class="stk-optsum__v">' + esc(val) + tag + '</span></span>' +
          '<span class="stk-optsum__ed">' + ICON.edit + '</span></button>';
      });
      var n = designs();
      var more = !full();
      /* same words as the upload box's own count: "1 of 4 uploaded". Named
         slots (a sticker sheet and its optional background, a bookmark and its
         optional backing card) are ONE design in parts, so there it is
         "Artwork: Uploaded" (Thomas, 24 Sep: "sticker sheet says 'designs' but
         its one design"). */
      var named = widget.classList.contains('sau-named');
      var cnt = widget.querySelector('.sau-dz-count');
      /* P172 (2 Oct 2026): box title and value in the page language */
      var key = named ? stkT('stk.labs.sheet.artwork', 'Artwork') : stkT('stk.studio.order.designs', 'Designs');
      var said = named ? stkT('stk.main_product.optsum_uploaded', 'Uploaded') : (cnt && cnt.textContent.trim() ? cnt.textContent.trim() : String(n));
      cells.push('<button type="button" class="stk-optsum__cell" data-opt="designs" aria-label="' + esc(fill(more ? stkT('stk.main_product.optsum_more_aria', 'Upload more artwork, [n] uploaded') : stkT('stk.main_product.optsum_done_aria', 'Your uploaded artwork, [n] uploaded'), { n: n })) + '">' +  /* P172 */
        '<span class="stk-optsum__ic">' + ICON.designs + '</span>' +
        '<span class="stk-optsum__tx"><span class="stk-optsum__k">' + esc(key) + '</span><span class="stk-optsum__v">' + esc(said) + '</span></span>' +
        '<span class="stk-optsum__ed">' + (more ? ICON.plus : ICON.edit) + '</span></button>');
      sum.innerHTML = '<div class="stk-optsum__grid">' + cells.join('') + '</div><p class="stk-optsum__hint">' + esc(stkT('stk.main_product.optsum_hint', 'Tap a box to change it')) + '</p>';  /* P172 */
      fit();
    }

    /* Every box is two lines, name and value (Thomas: the bookmark Style
       "cant ... trail onto 3 lines"). Measured 24 Sep: a 2x2 box leaves ~97px
       for the value on a phone and on the bookmark page's desktop column,
       and "DIY KIT (NO MAGNETS)" is 157px, backing-card sizes 266px. So when
       any value will not fit its box the summary becomes one box per row, and
       a value still too wide steps down to 12px before it ellipses. */
    function fit() {
      if (sum.hidden) return;
      var vals = sum.querySelectorAll('.stk-optsum__v');
      sum.classList.remove('stk-optsum--list');
      Array.prototype.forEach.call(vals, function (v) { v.style.fontSize = ''; });
      var over = Array.prototype.some.call(vals, function (v) { return v.scrollWidth > v.clientWidth + 1; });
      if (over) sum.classList.add('stk-optsum--list');
      Array.prototype.forEach.call(vals, function (v) {
        var size = parseFloat(getComputedStyle(v).fontSize);
        while (v.scrollWidth > v.clientWidth + 1 && size > 12) {
          size -= 0.5;
          v.style.fontSize = size + 'px';
        }
      });
    }
    var fitT;
    window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fit, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    /* the Done button lives inside the card, so it is put back after every
       Dawn swap while the card is open with artwork in */
    /* Phones only (Thomas, 24 Sep: "i dont want those on desktop anymore. only
       mobile."). Under 750px, Dawn's phone layout, the options fold after an
       upload; wider, they stay open as they always were and no Done is added.
       Crossing the line (rotating a tablet, resizing a window) unfolds. */
    var phoneMq = window.matchMedia('(max-width: 749px)');
    function isPhone() { return phoneMq.matches; }

    function ensureDone() {
      var v = current();
      var card = v && (v.querySelector('.vpick-group--card') || v);
      if (!card) return;
      var btn = card.querySelector('.stk-optsum__done');
      var want = isPhone() && !folded && designs() > 0;
      if (want && !btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'stk-optsum__done';
        btn.innerHTML = ICON.check + '<span>' + esc(stkT('stk.labs.svg.progress.done', 'Done')) + '</span>';  /* P172 */
        card.appendChild(btn);
      } else if (!want && btn) {
        btn.remove();
      }
    }

    /* swap the tall card and the summary, animating the height of whichever
       comes in from the height of whichever goes out, and keep the artwork
       card where it was on screen while the page above it changes height */
    function setFolded(on, opts) {
      opts = opts || {};
      if (on === folded) { if (on) render(); ensureDone(); return; }
      var v = current();
      var outEl = on ? v : sum;
      var inEl = on ? sum : v;
      var from = outEl ? outEl.getBoundingClientRect().height : 0;
      var a = anchor();
      var holdAnchor = on;
      var a0 = a.getBoundingClientRect().top;
      folded = on;
      host.classList.toggle('stk-optsum--on', on);
      sum.hidden = !on;
      if (on) render();
      ensureDone();
      if (!on) replaceChips();
      if (!inEl || reduced || !from) {
        if (holdAnchor) window.scrollBy(0, a.getBoundingClientRect().top - a0);
        if (opts.focus) opts.focus();
        return;
      }
      var to = inEl.getBoundingClientRect().height;
      inEl.style.overflow = 'hidden';
      inEl.style.height = from + 'px';
      void inEl.offsetHeight;
      inEl.style.transition = 'height ' + DUR + 'ms ease';
      inEl.style.height = to + 'px';
      var start = performance.now();
      (function frame(now) {
        if (holdAnchor) {
          var d = a.getBoundingClientRect().top - a0;
          if (d) window.scrollBy(0, d);
        }
        if (now - start < DUR + 40) { requestAnimationFrame(frame); return; }
        inEl.style.transition = '';
        inEl.style.height = '';
        inEl.style.overflow = '';
        if (!on) replaceChips();
        if (opts.focus) opts.focus();
      })(start);
    }

    sum.addEventListener('click', function (e) {
      var cell = e.target.closest('.stk-optsum__cell');
      if (!cell) return;
      if (cell.dataset.opt === 'designs') {
        var dz = dropzone();
        if (!full() && dz) { dz.click(); return; }
        /* full: show the uploaded list to edit. If the upload panel is shut,
           its tile opens it (the app ignores the browse when full). */
        if (document.querySelector('.stka2-fields--closed')) {
          var tg = document.querySelector('[data-stka2-toggle]');
          if (tg) tg.click();
        }
        var list = widget.querySelector('.sau-ready') || anchor();
        list.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var idx = +cell.dataset.opt;
      setFolded(false, {
        focus: function () {
          var v = current();
          var f = v && v.querySelectorAll('fieldset')[idx];
          if (f) f.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        },
      });
    });

    host.addEventListener('click', function (e) {
      if (e.target.closest('.stk-optsum__done')) setFolded(true);
    });

    function onFiles() {
      var n = designs();
      if (n > lastCount && isPhone()) setFolded(true);   /* every new upload folds, on a phone */
      else if (n === 0) setFolded(false);        /* no artwork, no fold */
      else if (folded) render();                 /* removed one: new count */
      else ensureDone();
      lastCount = n;
    }
    new MutationObserver(onFiles).observe(widget, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-disabled'] });
    /* Dawn swapped <variant-selects>: re-read the choices, restore Done */
    new MutationObserver(function () {
      if (folded) render();
      ensureDone();
    }).observe(host, { childList: true });
    var onWidth = function () {
      if (!isPhone() && folded) setFolded(false);
      ensureDone();
    };
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onWidth);
    else if (phoneMq.addListener) phoneMq.addListener(onWidth);
    onFiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
